import GuestFormReview from "@modules/study/university/uni_reviews/components/guest_form_review";
import RegisterFormReview from "@modules/study/university/uni_reviews/components/register_form_review";
import { Backdrop, Grid, Modal } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import { authAtom } from "@_recoil/_state";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { FiX } from "react-icons/fi";
import API from "@unisearch/helpers/api";
import styles from "./uni_review_box.module.scss";

const ReviewOption = ({
  value,
  uniProfileData,
  setModal,
  getData,
  existingComment,
  onEdit,
  getComment,
}) => {
  switch (value) {
    case 0:
      return (
        <GuestFormReview
          getData={getData}
          setModal={setModal}
          uniProfileData={uniProfileData}
        />
      );

    case 1:
      return (
        <RegisterFormReview
          setModal={setModal}
          uniProfileData={uniProfileData}
          getData={getData}
          onEdit={onEdit}
          existingComment={existingComment}
          getComment={getComment}
        />
      );
  }
};

export const UniReviewBox = ({ uniProfileData }) => {
  const profileInfo = useRecoilValue(authAtom);
  const [modal, setModal] = useState(false);
  const [value, setValue] = useState(0);
  const [existingComment, setExistingComment] = useState({});
  const [onEdit, setOnEdit] = useState(false);

  // get existing comment
  const getComment = async () => {
    await API.get(
      `/public/university-review/check/${uniProfileData?.universitySlug}`
    ).then((res) => {
      if (!res.error && res.data) {
        const { data } = res;
        setExistingComment(data);
        setOnEdit(true);
      } else {
        setExistingComment({});
        setOnEdit(false);
      }
    });
  };

  useEffect(() => {
    if (uniProfileData?.universitySlug && profileInfo && modal) {
      getComment();
    }
  }, [uniProfileData?.universitySlug, profileInfo, modal]);

  useEffect(() => {
    if (profileInfo) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [profileInfo]);

  const getData = () => {};

  return (
    <div className="container">
      <div className={styles.wrapper}>
        <Grid container spacing={4} alignItems="center">
          <Grid item md={6} sm={12} xs={12}>
            <div className={styles.left_wrapper}>
              <h2 className={styles.heading}>Review This University!</h2>
              <p className={styles.description}>
                Are you a student or alumnus of this university? Share your
                review with prospective students.
              </p>
            </div>
          </Grid>
          <Grid
            item
            md={6}
            sm={12}
            xs={12}
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <div
              className={styles.right_wrapper}
              onClick={() => {
                setModal(true);
              }}
            >
              <div className={styles.img_wrapper}>
                <img src={getAssets("assets/five_star.png")} alt="five_star" />
              </div>
              <p className={styles.action}>Rate this university</p>
            </div>
          </Grid>
        </Grid>
      </div>
      <Modal
        open={modal}
        onClose={() => {
          setModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="modal md">
          <div className={`modal_head ${styles.modal_header}`}>
            <h4 className={`${styles.title} modal_title`}></h4>
            <button
              className={`cross_icon ${styles.cross_action}`}
              onClick={() => {
                setModal(false);
              }}
            >
              <FiX />
            </button>
          </div>

          <div className={`${styles.modal_body} modal_body`}>
            {profileInfo?.userTypeSlug == "university" ? (
              <>
                <h4 className={styles.modal_title}>Writing Review</h4>
                <p className="center">You can't give review yourself</p>
              </>
            ) : (
              <>
                <h4 className={styles.modal_title}>Write a Review</h4>
                <p className={styles.modal_description}>
                  Are you a current student or alumnus of this university? Let
                  us know more about your experience, and what prospective
                  international students can expect applying to and enrolling
                  here!
                </p>
                {!profileInfo && (
                  <div className={styles.action_btn}>
                    <button
                      onClick={() => {
                        setValue(0);
                      }}
                      className={value === 0 && styles.active_btn}
                    >
                      Guest User
                    </button>
                    <button
                      onClick={() => {
                        setValue(1);
                      }}
                      className={value === 1 && styles.active_btn}
                    >
                      Registered User
                    </button>
                  </div>
                )}
                <ReviewOption
                  setModal={setModal}
                  uniProfileData={uniProfileData}
                  value={value}
                  getData={getData}
                  existingComment={existingComment}
                  onEdit={onEdit}
                  getComment={getComment}
                />
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UniReviewBox;
